module.exports = __webpack_public_path__ + "assets/retina_ParallelogramBySPDetailed.7fe1a9b091daf0c509b362ec13b039d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ParallelogramBySPDetailed.png
// module id = 701
// module chunks = 0